module.exports = __webpack_public_path__ + "static/media/mym.56135483.png";